import React, {useState} from 'react';
import Layout from '../Shared/Layout';
import {Container, Grid, Paper} from "@material-ui/core";
import styled from "styled-components";

const CardA = styled.a`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  text-align: center;
  padding: 30px;
  font-size: 20px;
  display: block;
  text-decoration: none;
  color: ${props => props.theme.text};
  height: 100%;
`;

export default function DashboardB2X({ userClients, client }) {
    const filteredClients = userClients.filter(item => item.id !== client.id);
    return (
        <div className={"mb-12"}>
            <Container maxWidth="lg">
                <Grid container spacing={3} justify={"center"}>
                    {
                        filteredClients.map(client => (
                            <Grid item xs={12} sm={3}>
                                <CardA href={route("client.switch", { client_id: client.id })} style={{ color: client.brand_color_header_icons,  backgroundColor: client.brand_color_header }}>
                                    <img src={client.brand_logo} alt={client.name} className={"h-9"}/>
                                    <h2>
                                        { client.name }
                                    </h2>
                                    {/* <p style={{ fontSize: 16 }}>
                                        <Trans i18nKey="emissions.co2Calc.description">
                                            Calculate the CO2e emissions of your
                                            device repair.
                                        </Trans>
                                    </p> */}
                                </CardA>
                            </Grid>
                        ))
                    }
                </Grid>
            </Container>
        </div>
    );
}

DashboardB2X.layout = page => <Layout children={page} />;
